// Copyright (c) Mysten Labs, Inc.
// SPDX-License-Identifier: Apache-2.0
import { SVGProps } from "react";

const SvgArrowShowAndHideRight12 = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="1em"
		height="1em"
		fill="none"
		viewBox="0 0 12 12"
		{...props}
	>
		<path
			fill="currentColor"
			d="M9.25 5.567a.5.5 0 0 1 0 .866l-4.5 2.598A.5.5 0 0 1 4 8.598V3.402a.5.5 0 0 1 .75-.433l4.5 2.598Z"
		/>
	</svg>
);
export default SvgArrowShowAndHideRight12;
